import getProductAvailability, { InventryLocation, OrderTypes } from "@dana/Handlers/ProductAvailabilityHandler";
import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontSizes, fontWeights, lineHeights } from "@dana/MobiusOverrides/styles/typography";
import { ProductAddToCartButtonStyles } from "@dana/Overrides/Components/ProductAddToCartButton";
import { addDanaLineCollection, danaBatchCheck } from "@dana/Overrides/Services/CartService";
import ApplicationStateDana from "@dana/Store/DanaApplicationState";
import setAddCartLinesLoaderFlag from "@dana/Store/Data/AddCartLinesLoader/Handlers/AddCartLinesLoaderHandler";
import resetWishlistavAilability from "@dana/Store/Data/WishlistAvailability/Handlers/ResetAvailabilityHandler";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getDanaGeneralSettings } from "@dana/Store/Context/ContextSelectors";
import usePollConfig from "@dana/Common/Hooks/usePollConfig";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getShipToState } from "@insite/client-framework/Store/Data/ShipTos/ShipTosSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { CartLineCollectionModel, CartLineModel, WishListLineModel } from "@insite/client-framework/Types/ApiModels";
import Button from "@insite/mobius/Button";
import Checkbox from "@insite/mobius/Checkbox";
import Clickable from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import Modal from "@insite/mobius/Modal";
import { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Tooltip, { TooltipPresentationProps } from "@insite/mobius/Tooltip";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { setCookie } from "@insite/mobius/utilities/cookies";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState, useEffect, useContext, useRef } from "react";
import { connect, ResolveThunks } from "react-redux";
import styled, { css } from "styled-components";

const mapStateToProps = (state: ApplicationStateDana) => {
    const wishlistAvailability = state.wishlistAvailabilityState;
    const productAvailabilityState = state.productAvailabilityState;
    const session = getSession(state);
    const shipToCustomer = getShipToState(state, state.context.session.shipToId);
    const billtoCustomer = getBillToState(state, state.context.session.billToId);
    const currentLanguage = state.context.session.language;
    const currency = state.context.session?.currency;

    return {
        wishlistAvailability,
        productAvailabilityState,
        session,
        shipToCustomer,
        billtoCustomer,
        currentLanguage,
        currency,
        cartPageLink: getPageLinkByPageType(state, "CartPage"),
        danaGeneralSettings: getDanaGeneralSettings(state),
    }
};
const mapDispatchToProps = {
    getProductAvailability,
    resetWishlistavAilability
};


export interface ProductAvaibilityDetailsStyles {
    container?: GridContainerProps;
    orderTypeGridItem?: GridItemProps;
    handleButtonWrapper?: GridItemProps;
    orderType?: TypographyPresentationProps;
    orderSelect?: SelectPresentationProps;
    availabilityGridItem?: GridItemProps;
    currentAvailabilityTextWrapper?: InjectableCss;
    currentAvailabilityText?: TypographyPresentationProps;
    tooltipText?: TooltipPresentationProps;
    messageStyles?: InjectableCss;
    increaseQuantity?: InjectableCss;
    increaseQtyText?: TypographyPresentationProps;
    increaseQtyField?: TextFieldPresentationProps;
    locationTableGrid?: GridItemProps;
    locationTitle?: TypographyPresentationProps;
    locationCity?: TypographyPresentationProps;
    quantity?: TypographyPresentationProps;
    date?: TypographyPresentationProps;
    modalFooter?: GridItemProps;
    modalPricingContainer?: GridContainerProps;
    pricingDetails?: InjectableCss;
    pricingBox?: InjectableCss;
    priceLabel?: TypographyPresentationProps;
    priceAmount?: TypographyPresentationProps;
    addToCartGrid?: GridItemProps;
    addToCartButtonStyle?: ProductAddToCartButtonStyles;
    errorMsgBox?: InjectableCss;
}

export const productAvaibilityDetailsStyles: ProductAvaibilityDetailsStyles = {
    container: {
        gap: 0,
        isFullWidth: true,
    },
    orderTypeGridItem: {
        css: css`
            gap: 16px;
            padding-bottom: 24px;
        `,
    },
    orderType: {
        variant: "h2",
        css: css`
            margin-bottom: 0;
            flex-shrink: 0;
            flex: 1;
        `,
    },
    orderSelect: {
        cssOverrides: {
            formField: css`
                flex: 1;
            `,
        },
    },
    availabilityGridItem: {
        css: css`
            @media screen and (max-width: 768px) {
                flex-direction: column;
                align-items: flex-start;
            }
        `,
    },
    currentAvailabilityTextWrapper: {
        css: css`
            flex: 1;
        `,
    },
    currentAvailabilityText: {
        weight: fontWeights.bold,
    },
    tooltipText: {
        mergeCss: true,
        cssOverrides: {
            tooltipBody: css`
                font-weight: ${fontWeights.regular};
            `,
        },
    },
    messageStyles: {
        css: css`
            margin: 16px 0;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
            .info-message-box {
                display: block;
                font-size: ${fontSizes.small};
            }
        `,
    },
    increaseQuantity: {
        css: css`
            flex: 1;
            display: flex;
            align-items: flex-start;
            gap: 16px;
        `,
    },
    increaseQtyText: {
        size: fontSizes.small,
        lineHeight: lineHeights.default,
        color: themeBackgrounds.darkGray,
        css: css`
            text-align: right;

            @media screen and (max-width: 768px) {
                text-align: left;
            }
        `,
    },
    increaseQtyField: {
        cssOverrides: {
            formField: css`
                max-width: 80px;
            `,
        },
        css: css`
            &::-webkit-inner-spin-button,
            &::-webkit-outer-spin-button {
                opacity: 1;
                transform: scale(1.4);
            }
            -moz-appearance: number-input;
        `,
    },
    locationTableGrid: {
        css: css`
            @media screen and (max-width: 768px) {
                overflow-x: scroll;
            }
        `,
    },
    locationTitle: {
        weight: fontWeights.semiBold,
    },
    locationCity: {
        weight: fontWeights.regular,
        color: themeBackgrounds.darkGray,
    },
    quantity: {
        weight: fontWeights.semiBold,
        color: themeBackgrounds.darkGray,
    },
    date: {
        weight: fontWeights.semiBold,
        color: themeBackgrounds.darkGray,
    },
    modalFooter: {
        css: css`
            align-items: center;
            justify-content: space-between;
            padding-top: 24px;

            @media screen and (max-width: 768px) {
                flex-direction: column;
                align-items: flex-start;
                gap: 20px;
            }

            .footer-info-text {
                font-size: ${fontSizes.small};
                line-height: ${lineHeights.default};
            }
        `,
    },
    modalPricingContainer: {
        offsetCss: css`
            flex-direction: row;
            justify-content: space-between;
            gap: 8px;
        `,
    },
    pricingDetails: {
        css: css`
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 8px;
            margin-bottom: 24px;
        `,
    },
    pricingBox: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
        `,
    },
    priceLabel: {
        size: fontSizes.small,
        weight: fontWeights.semiBold,
        lineHeight: lineHeights.default,
    },
    priceAmount: {
        css: css`
            &.extended-price {
                font-weight: ${fontWeights.bold};
            }
        `,
    },
    addToCartGrid: {
        css: css`
            justify-content: space-between;
            gap: 8px;
            [data-test-selector="addToListLink"],
            button {
                flex-shrink: 0;
            }
        `,
    },
    addToCartButtonStyle: {
        button: {
            css: css`
                flex-shrink: 0;
            `,
        },
        messageStylesWrapper: {
            css: css`
                display: flex;
                justify-content: space-between;
                flex-direction: row;
                flex-shrink: 1;
                flex-basis: 100%;
                max-width: 100%;
                align-items: flex-start;
            `,
        },
        messageStyles: {
            css: css`
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                gap: 8px;
                .info-message-box {
                    display: block;
                    font-size: ${fontSizes.small};
                }
            `,
        },
    },
    errorMsgBox: {
        css: css`
            display: flex;
            align-items: center;
            gap: 4px;
            margin-top: 8px;
            width: 100%;
        `,
    },

    handleButtonWrapper: {
        css: css`
            gap: 16px;
            align-items: baseline;
        `
    }
};

const styles = productAvaibilityDetailsStyles;

const StyledTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    overflow-x: auto;
    margin-top: 32px;

    thead {
        background-color: ${themeBackgrounds.white};

        th {
            font-size: ${fontSizes.xSmall};
            line-height: ${lineHeights.default};
            color: ${themeBackgrounds.darkGray};
        }

        td {
            color: ${themeBackgrounds.darkGray};
        }
    }

    tbody {
        td {
            font-size: ${fontSizes.small};
            line-height: ${lineHeights.default};
        }
    }

    th,
    td {
        padding: 8px;
        border: 1px solid ${themeBackgrounds.lightGray};
        text-align: left;
        white-space: nowrap;
    }

    th:nth-child(1),
    td:nth-child(1) {
        min-width: 250px;
    }
`;


type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

const WishlistAvailabilityModal: React.FC<Props> = ({
    wishlistAvailability,
    productAvailabilityState,
    session,
    shipToCustomer,
    getProductAvailability,
    resetWishlistavAilability,
    currentLanguage,
    currency,
    cartPageLink,
    danaGeneralSettings,
    history
}) => {
    const [wishListLines, setWishlistLines] = useState<WishListLineModel[]>([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [currentListLine, setCurrentListLine] = useState<WishListLineModel | undefined>(undefined);
    const [selectedItems, setSelectedItems] = useState<WishListLineModel[]>([]);
    const [locations, setLocations] = useState<InventryLocation[]>([]);
    const [loading, setLoading] = useState(productAvailabilityState.isLoading);
    const [showPopup, setShowPopup] = useState(wishlistAvailability.showPopup);
    const [qty, setQty] = useState("0");
    const [finalQty, setFinalQty] = useState("0");
    const [locationSelectedForCurrent, setLocationSelectedForCurrent] = useState(false);
    const toasterContext = useContext(ToasterContext);
    const [selectedLocation, setLocation] = React.useState<string[]>();
    const [isPolling, setIsPolling] = useState(false);
    const pollIntervalRef = useRef<NodeJS.Timeout | null>(null);
    const pollTimeoutRef = useRef<NodeJS.Timeout | null>(null);
    const { pollIntervalMs, pollTimeoutMs } = usePollConfig();

    useEffect(() => {
        if (wishlistAvailability.wishListLineCollection?.length) {
            setWishlistLines(wishlistAvailability?.wishListLineCollection);
        } else if (wishlistAvailability.wishList?.wishListLineCollection) {
            setWishlistLines(wishlistAvailability?.wishList?.wishListLineCollection);
        }

    }, [wishlistAvailability.wishListLineCollection]);

    useEffect(() => {
        setLocations(productAvailabilityState.locations)
        setLoading(productAvailabilityState.isLoading);
    }, [productAvailabilityState.isLoading, productAvailabilityState.locations]);
    useEffect(() => {
        setShowPopup(wishlistAvailability.showPopup);
    }, [wishlistAvailability.showPopup]);
    useEffect(() => {
        if (wishListLines.length && wishListLines[currentIndex]) {
            setCurrentListLine(wishListLines[currentIndex]);
            setQty(wishListLines[currentIndex].qtyOrdered.toString());
            setFinalQty(wishListLines[currentIndex].qtyOrdered.toString());
            setLocationSelectedForCurrent(
                selectedItems.some(sel => sel.id === wishListLines[currentIndex].id)
            );
        }
    }, [wishListLines, currentIndex, selectedItems]);

    useEffect(() => {
        if (currentListLine && shipToCustomer) {
            setLoading(true);
            getProductAvailability({
                productNumber: currentListLine.erpNumber,
                plantCode: session?.properties?.plantCode,
                quantity: parseInt(qty, 10),
                orderType: OrderTypes.EMERGENCY,
                customerNumber: shipToCustomer?.value?.customerSequence ?? "null",
            });
        }
    }, [finalQty, currentListLine, shipToCustomer]);
    const handleToggleLocation = (value: string) => {
        setLocation(prev => {
            if (!prev) return [value];
            return prev.includes(value)
                ? prev.filter(item => item !== value)
                : [...prev, value];
        });
    };
    const handleSelect = (location: InventryLocation, currentListLine: WishListLineModel | undefined) => {
        if (!currentListLine) return;

        handleToggleLocation(location.id);
        setSelectedItems(prevItems => {
            const newItem: WishListLineModel = {
                ...currentListLine,
                qtyOrdered: location.committedQuantity,
                properties: {
                    ...currentListLine.properties,
                    location: location.location.properties.plantCode,
                    estimatedShipDate: location.committedDate ? formatDate(location.committedDate) : ""
                }
            };

            const exists = prevItems.some(item => item.id === newItem.id && item.properties.location === newItem.properties.location && (location?.committedDate && item.properties.estimatedShipDate === formatDate(location?.committedDate)));
            if (exists) {
                return prevItems.map(item => ((item.id === newItem.id && item.properties.location === newItem.properties.location && (location?.committedDate && item.properties.estimatedShipDate === formatDate(location?.committedDate))) ? newItem : item));
            }
            return [...prevItems, newItem];
        });

        setLocationSelectedForCurrent(true);
    };

    const handleNext = () => {
        if (currentIndex < wishListLines.length - 1) {
            setCurrentIndex(prev => prev + 1);
        }
    };

    const handleSkip = () => {
        setLocationSelectedForCurrent(false);
        handleNext();
    };

    const handleSelectAndNext = () => {
        handleNext();
    };

    useEffect(() => {
        return () => { stopPolling(); };
    }, []);

    const stopPolling = () => {
        if (pollIntervalRef.current) { clearInterval(pollIntervalRef.current); pollIntervalRef.current = null; }
        if (pollTimeoutRef.current) { clearTimeout(pollTimeoutRef.current); pollTimeoutRef.current = null; }
        setIsPolling(false);
    };

    const startPolling = () => {
        if (pollIntervalRef.current) return;
        setIsPolling(true);

        pollIntervalRef.current = setInterval(() => {
            danaBatchCheck('?IsEmergencyOrder=true').then(result => {
                if (result.success) {
                    stopPolling();
                    toasterContext.addToast({ body: `${translate("items uploaded")}`, messageType: "success" });
                    setAddCartLinesLoaderFlag({ isLoading: false });
                    if (cartPageLink) {
                        history.push(cartPageLink.url);
                    }
                }
            }).catch(() => { /* continue polling on transient errors */ });
        }, pollIntervalMs);

        pollTimeoutRef.current = setTimeout(() => {
            stopPolling();
            toasterContext.addToast({
                body: translate("Error adding items to the cart."),
                messageType: "warning",
                isFocusAfterMount: true,
            });
        }, pollTimeoutMs);
    };

    const handleAddToCart = () => {
        const cartLines: CartLineModel[] = selectedItems.map(item => item) as any;
        setCookie("cartMode", "EmergencyOrderCart");
        setCookie("modalOrderType", OrderTypes.EMERGENCY);
        setLoading(true);
        addDanaLineCollection({
            cartId: API_URL_CURRENT_FRAGMENT,
            cartLineCollection: { cartLines } as CartLineCollectionModel,
            additionalQueryStringParameters: {
                IsEmergencyOrder: true
            }
        }).then(() => {
            const lineCount = cartLines.length;
            if (danaGeneralSettings && lineCount >= parseInt(danaGeneralSettings.largeCartItemsThresholdBatchSize, 10)) {
                startPolling();
            } else {
                toasterContext.addToast({ body: `${translate("items uploaded")}`, messageType: "success" });
                setLoading(false);
                if (cartPageLink) {
                    history.push(cartPageLink.url);
                }
            }
        });


    };

    const formatDate = (isoString: string): string => {
        const date = new Date(isoString);
        return new Intl.DateTimeFormat(currentLanguage?.languageCode).format(date);
    };

    const handleCloseModel = () => {
        resetWishlistavAilability({});
    };

    const isLastItem = currentIndex === wishListLines.length - 1;
    const atLeastOneSelected = selectedItems.length > 0;

    return (
        <Modal
            headline={(<Clickable onClick={handleCloseModel}>{"<-"}{translate("BACK TO LIST")}</Clickable>)}
            isOpen={showPopup}
            isCloseable={false}
            handleClose={handleCloseModel}
        >
            <LoadingOverlay loading={loading}>
                <GridContainer {...styles.container}>
                    <GridItem width={12} {...styles.availabilityGridItem}>
                        {`${currentListLine?.erpNumber ?? ""} ${currentListLine?.shortDescription ?? ""}`}
                    </GridItem>

                    <GridItem width={12} {...styles.availabilityGridItem}>
                        <StyledWrapper {...styles.currentAvailabilityTextWrapper}>
                            <Typography {...styles.currentAvailabilityText}>
                                {translate("Current Availability")}{" "}
                                {productAvailabilityState?.productAvailability?.availableQuantity}
                            </Typography>
                        </StyledWrapper>
                        <StyledWrapper {...styles.increaseQuantity}>
                            <Typography {...styles.increaseQtyText}>
                                {translate("Quantity:")}
                            </Typography>
                            <TextField
                                {...styles.increaseQtyField}
                                type="number"
                                value={qty}
                                onChange={event => setQty(event.target.value)}
                                onBlur={() => setFinalQty(qty)}
                            />
                        </StyledWrapper>
                    </GridItem>


                    <GridItem width={12} {...styles.locationTableGrid}>
                        <StyledTable>
                            <thead>
                                <tr>
                                    <th>{translate("Location")}</th>
                                    <th>{translate("Qty")}</th>
                                    <th>{translate("Estimated Ship Date")}</th>
                                    {session.isAuthenticated ? <th>{translate("Select Location")}</th> : ""}
                                </tr>
                            </thead>
                            <tbody>
                                {locations && locations?.map((loc: InventryLocation) => {

                                    const estShipDate =
                                        loc?.committedDate
                                            ? formatDate(loc.committedDate)
                                            : "";
                                    const commitedQuantity =
                                        loc?.committedQuantity
                                            ? loc?.committedQuantity
                                            : 0;
                                    return (
                                        <tr key={loc?.location.id}>
                                            <td>
                                                <Typography {...styles.locationTitle}>
                                                    {loc?.location?.description},{" "}
                                                    <Typography {...styles.locationCity}>
                                                        {loc?.location.city}, {loc?.location.state}
                                                    </Typography>
                                                </Typography>
                                            </td>
                                            <td>
                                                <Typography {...styles.quantity}>{commitedQuantity}</Typography>
                                            </td>
                                            <td>
                                                <Typography {...styles.date}>{estShipDate}</Typography>
                                            </td>
                                            {session.isAuthenticated ? (<td>
                                                <Checkbox
                                                    checked={selectedItems.some(
                                                        sel =>
                                                            sel.id === currentListLine?.id &&
                                                            sel.properties?.location === loc?.location.properties.plantCode &&
                                                            selectedLocation && selectedLocation.length > 0 && selectedLocation.includes(loc?.id)
                                                    )}
                                                    onChange={() => handleSelect(loc, currentListLine)}
                                                />
                                            </td>) : ""}

                                        </tr>
                                    );
                                })}
                            </tbody>
                        </StyledTable>
                    </GridItem>


                    <GridItem width={12} {...styles.modalFooter}>
                        <GridContainer gap={0} {...styles.modalPricingContainer}>
                            <GridItem width={12}>
                                <StyledWrapper className="pricing-details-row" {...styles.pricingDetails}>
                                    <StyledWrapper className="unit-price" {...styles.pricingBox}>
                                        <Typography {...styles.priceLabel}>
                                            {translate("Unit Price ({0})", currency?.currencyCode ?? "USD")}{" "}
                                            <Tooltip
                                                {...styles.tooltipText}
                                                text='Pricing displayed represents your current, agreed, every-day, "Standard Net Price", and does not reflect any special / promotional pricing or discounts that may be available. If you have questions, please contact Customer Operations at (800) 621-8084.'
                                            />
                                        </Typography>
                                        <Typography {...styles.priceAmount}>
                                            {productAvailabilityState?.productCustomerPrice?.unitListPriceDisplay}
                                        </Typography>
                                    </StyledWrapper>
                                    <StyledWrapper className="extended-price" {...styles.pricingBox}>
                                        <Typography {...styles.priceLabel}>
                                            {translate("Extended Price ({0})", currency?.currencyCode ?? "USD")}
                                        </Typography>
                                        <Typography {...styles.priceAmount} className="extended-price">
                                            {productAvailabilityState?.productCustomerPrice?.extendedUnitListPriceDisplay}
                                        </Typography>
                                    </StyledWrapper>
                                </StyledWrapper>
                            </GridItem>
                            <GridItem width={12}>
                                <Typography variant="h4" style={{ marginBottom: "1rem" }}>
                                    {translate("Record")} {currentIndex + 1} / {wishListLines.length}
                                </Typography>
                            </GridItem>
                            <GridItem width={12} className="handle-button-wrapper" {...styles.handleButtonWrapper}>

                                {isLastItem && atLeastOneSelected && (
                                    <Button color="primary" onClick={handleAddToCart}>
                                        {translate("Add to Cart")}
                                    </Button>
                                )}
                                {isLastItem && !atLeastOneSelected && (
                                    <Button color="primary" disabled={true} >
                                        {translate("Add to Cart")}
                                    </Button>
                                )}
                                {!isLastItem && (
                                    <>
                                        <Button variant="secondary" onClick={handleSkip}>
                                            {translate("Skip & Go Next")}
                                        </Button>
                                        <Button
                                            color="primary"
                                            onClick={handleSelectAndNext}
                                            disabled={!locationSelectedForCurrent}
                                        >
                                            {translate("Select & Go Next")}
                                        </Button>
                                    </>
                                )}
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </LoadingOverlay >
        </Modal >
    );
};
export default connect(mapStateToProps, mapDispatchToProps)(withHistory(WishlistAvailabilityModal));